import { Supervisor, Client } from '@api';

export const formatClientOrSupervisor = (type?: Supervisor | Client): string => {
  if (!type) {
    return '';
  }
  return `${type.name} (${type.tag})`;
};
